"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.createNotifier = createNotifier;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Simple, explicit eventing system.
 *
 * @returns {registerHandler}
 */
function createNotifier() {
  var registrations = [];

  function registerHandler(fn) {
    registrations = [].concat((0, _toConsumableArray3.default)(registrations), [fn]);
    return function unregisterHandler() {
      registrations = registrations.filter(function (x) {
        return x !== fn;
      });
    };
  }

  function notify() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    registrations.forEach(function (fn) {
      return fn.apply(undefined, args);
    });
  }

  registerHandler.notify = notify;
  return registerHandler;
}
//# sourceMappingURL=notifier.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/misc/notifier.js
// module id = 633
// module chunks = 0